export enum BrandCode {
  LBEL = "L",
  ESIKA = "E",
  CYZONE = "C",
}

export interface Product {
  id: string;
  cuv: string;
  category?: Category;
  cuvParent: string;
  description: string;
  images?: Images;
  name: string;
  nameVariant: string;
  sku: string;
  order: null;
  pricing?: Pricing;
}

export interface Category {
  id: string;
  image: string;
}

export interface Images {
  main: string;
  variant: string;
}

export interface Pricing {
  currencyCode: string;
  currencySymbol: string;
  normalPrice: number;
  offerPrice: number;
}

export interface Base {
  codsap: string,
  nameProduct: string,
  typeProduct: string,
  tonality: string,
  codcuc: string,
  imageProduct: string
}
